import { ReferralTemplate } from "./ReferralTemplate";

export { ReferralTemplate };
export type { ReferralTemplateProps, ReferralTemplateContent } from "./ReferralTemplate.d";
